import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import styles from './EmptyState.m.sass';
var EmptyState = function EmptyState(_ref) {
  var className = _ref.className,
    title = _ref.title,
    icon = _ref.icon,
    children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles.root, className)
  }, icon && /*#__PURE__*/React.createElement("div", {
    className: styles.iconContainer
  }, icon), /*#__PURE__*/React.createElement("div", {
    className: styles.title
  }, title), children && /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, children));
};
EmptyState.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  icon: PropTypes.any
};
EmptyState.defaultProps = {
  title: 'Nothing to display.'
};
export default EmptyState;
//# sourceMappingURL=index.js.map
